import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaKey } from "react-icons/fa";
import LeftPanel from "./LeftPanel";
import apiClient from "../common/apiClient";

const VerifyOtp = () => {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [resendCount, setResendCount] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const mobile = location.state?.mobile;

    useEffect(() => {
        if (!mobile) {
            navigate("/forgetpassword");
        }
    }, [mobile, navigate]);

    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else {
            setCanResend(true);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
        if (error) setError("");
    };

    const handleResendOtp = async () => {
        if (resendCount >= 5) {
            setError("You have reached the maximum number of resend attempts (5).");
            setCanResend(false);
            return;
        }

        setLoading(true);
        setError("");
        try {
            const response = await apiClient(
                "post",
                "/cjidnvij/ceksfbuebijn/user/forgot-password/send-otp",
                { mobile }
            );

            if (response.success && response.data.success) {
                setTimer(60);
                setCanResend(false);
                setResendCount(prev => prev + 1);
            } else {
                setError(response.data?.message || "Failed to resend OTP.");
            }
        } catch (err) {
            setError("Failed to resend OTP. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!otp || otp.length < 4) {
            setError("Please enter a valid OTP.");
            setLoading(false);
            return;
        }

        try {
            const response = await apiClient(
                "post",
                "/cjidnvij/ceksfbuebijn/user/forgot-password/verify-otp",
                { mobile, otp }
            );

            if (response.success && response.data.success) {
                navigate("/resetpassword", { state: { mobile } });
            } else {
                setError(response.data?.message || response.error?.message || "Invalid OTP. Please try again.");
            }
        } catch (err) {
            setError("An unexpected error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex h-screen w-full overflow-hidden">
            <LeftPanel />
            <form
                onSubmit={handleSubmit}
                className="mx-4 lg:mx-28 mb-28 flex items-center"
            >
                <div className="flex-1 max-w-lg rounded-lg mt-10">
                    {/* <p className="text-4xl text-gray-800 mb-1">Welcome to</p>
                    <p className="text-5xl font-bold text-[#503691] mb-4">PRObroker</p> */}
                    <p className="text-3xl font-bold mb-4">Verify OTP</p>
                    <p className="text-gray-600 mb-6">Enter the OTP sent to <b>+91 {mobile}</b></p>

                    <div className="relative mb-4">
                        <FaKey className="absolute top-1/2 left-4 transform -translate-y-1/2 text-[#503691]" />
                        <input
                            type="number"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={handleOtpChange}
                            className="w-full px-10 py-3 border border-gray-300 rounded-md no-spinner"
                            required
                        />
                    </div>

                    {error && (
                        <div className="text-red-600 bg-red-50 border border-red-200 rounded-lg p-3 text-center mb-4 shadow-sm">
                            <div className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                                <span className="font-medium">{error}</span>
                            </div>
                        </div>
                    )}

                    <button
                        type="submit"
                        className="w-full h-11 bg-[#503691] text-white rounded-full font-semibold hover:bg-[#5b54e6] disabled:opacity-50"
                        disabled={loading}
                    >
                        {loading ? "Verifying..." : "Verify OTP"}
                    </button>

                    <div className="text-center mt-6">
                        {!canResend ? (
                            <>
                                <p className="text-gray-600 mb-1">Resend OTP?</p>
                                <p className="text-[#503691] font-bold">
                                    Your OTP will expire in {formatTime(timer)}
                                </p>
                            </>
                        ) : resendCount < 5 ? (
                            <button
                                type="button"
                                onClick={handleResendOtp}
                                className="text-[#503691] font-semibold hover:underline"
                                disabled={loading}
                            >
                                Resend OTP {resendCount > 0 && `(${5 - resendCount} attempts left)`}
                            </button>
                        ) : (
                            <p className="text-red-500 font-semibold text-sm">
                                Maximum resend attempts reached.
                            </p>
                        )}
                        <div className="mt-4">
                            {/* <button
                                type="button"
                                onClick={() => navigate("/forgetpassword")}
                                className="text-[#503691] text-sm hover:underline"
                            >
                                Change Mobile Number
                            </button> */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default VerifyOtp;
